module.exports = __webpack_public_path__ + "media/assets/pdf-e66189bc09c4328306d4e95e88bd2fc418dd0341cb84e2e66bb6ab5f8f4d8575.svg";